import { render, staticRenderFns } from "./GroupAssignmentEdit.vue?vue&type=template&id=97e268be"
import script from "./GroupAssignmentEdit.vue?vue&type=script&lang=js"
export * from "./GroupAssignmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports